<div *ngIf="type" class="sdg-button-container" [class.is-selected]="isSelected">
  <img
    [src]="(isSelected || isHighlighted) ? '/assets/images/sdg/E-WEB-Goal-' + type + '.svg' : '/assets/images/sdg/E-WEB-Goal-' + type + '-unselected.svg'"
    [alt]="'sdg number ' + type"
  />
</div>
